import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgArrowButtonLeft1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M10.416 12a2.64 2.64 0 0 1 .775-1.875L20.732.584a1.768 1.768 0 0 1 2.5 2.5l-8.739 8.739a.25.25 0 0 0 0 .354l8.739 8.739a1.768 1.768 0 0 1-2.5 2.5l-9.541-9.541A2.64 2.64 0 0 1 10.416 12"
      fill="currentColor"
    />
    <path
      d="M.25 12a2.64 2.64 0 0 1 .775-1.875L10.566.584a1.768 1.768 0 0 1 2.5 2.5l-8.739 8.739a.25.25 0 0 0 0 .354l8.739 8.739a1.768 1.768 0 0 1-2.5 2.5l-9.541-9.541A2.64 2.64 0 0 1 .25 12"
      fill="currentColor"
    />
  </svg>
);
